let baseUrl = window.location.origin + window.location.pathname.split("/").slice(0, 2).join("/") + "/";


export const CONFIG = {
    "baseURL": `https://ai.smartinfologiks.com/chat/api`,
    "homepage":"https://www.smartinfologiks.com/",
    "endPoints": {
        "get-models": "/chat/models",
        "post-msg": "/chat/msg",
        "get-theme": "/theme",
        "get-function": "/actions",
        "verify-login": "/auth/verify-login",
        "verify-guest-login":"/auth/verify-guest-login",
        "refresh-token":"/auth/refresh-token",
        "validate-session": "/auth/validate-session",
        "get-app-data": "/app-data",
        "examples": "/examples",
        "files": "/files",
        "upload-file":"/upload-file",
        "run-sandbox":"/run-sandbox",
        "export-mermaid":"/chat/export-mermaid"
    }

}